// QuickStats.jsx - Additional statistics display
import React from 'react';
import { Card, Row, Col, Statistic, Progress, Space } from 'antd';
import { 
  LineChartOutlined, 
  UserOutlined, 
  GlobalOutlined,
  CalendarOutlined 
} from '@ant-design/icons';

const QuickStats = () => {
  // Mock data - replace with real data from your state
  const stats = {
    totalViews: 15420,
    thisMonthViews: 2340,
    avgSessionTime: '3:42',
    bounceRate: 32,
    uniqueVisitors: 1250,
    returningVisitors: 65
  };

  const viewsGrowth = 23; // percentage growth
  const sessionsGrowth = 15;

  return (
    <Card 
      title={
        <div className="flex items-center space-x-2">
          <LineChartOutlined className="text-accent-blue" />
          <span>Analytics Overview</span>
        </div>
      }
      className="shadow-medium border border-border-light rounded-xl h-full"
    >
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Statistic
            title="Total Views"
            value={stats.totalViews}
            prefix={<GlobalOutlined />}
            valueStyle={{ color: '#19868d' }}
            suffix={
              <span className="text-xs text-green-600">
                +{viewsGrowth}%
              </span>
            }
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="This Month"
            value={stats.thisMonthViews}
            prefix={<CalendarOutlined />}
            valueStyle={{ color: '#10b981' }}
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="Avg. Session"
            value={stats.avgSessionTime}
            prefix={<UserOutlined />}
            valueStyle={{ color: '#f97316' }}
            suffix={
              <span className="text-xs text-green-600">
                +{sessionsGrowth}%
              </span>
            }
          />
        </Col>
        <Col span={12}>
          <Statistic
            title="Bounce Rate"
            value={stats.bounceRate}
            suffix="%"
            valueStyle={{ color: stats.bounceRate < 40 ? '#10b981' : '#f97316' }}
          />
        </Col>
      </Row>

      <div className="mt-6">
        <Space direction="vertical" size="middle" className="w-full">
          <div>
            <div className="flex justify-between mb-2">
              <span className="text-text-secondary text-sm">Unique Visitors</span>
              <span className="text-accent-blue font-semibold">{stats.uniqueVisitors}</span>
            </div>
            <Progress 
              percent={75} 
              strokeColor="#19868d"
              trailColor="#f1f5f9"
              showInfo={false}
            />
          </div>
          <div>
            <div className="flex justify-between mb-2">
              <span className="text-text-secondary text-sm">Returning Visitors</span>
              <span className="text-accent-green font-semibold">{stats.returningVisitors}%</span>
            </div>
            <Progress 
              percent={stats.returningVisitors} 
              strokeColor="#10b981"
              trailColor="#f1f5f9"
              showInfo={false}
            />
          </div>
        </Space>
      </div>
    </Card>
  );
};

export default QuickStats;